module.exports = __webpack_public_path__ + "static/media/cov_per_hyg.b154135f.png";